import clsx from 'clsx';
import { orderBy } from 'lodash';
import { func, object, string } from 'prop-types';
import { Link } from 'react-router-dom';

import { Icon, StrapiImg } from 'components';
import { routes } from 'router';

import 'assets/styles/components/navigation/submenu.scss';

const SubMenu = ({ content, setMenuOpen, classes = '' }) => {
  const orderedSubmenuCategory = content?.submenuCategory?.map((category) => ({
    ...category,
    submenuItem: orderBy(category.submenuItem, ['order'])
  }));

  const orderedSubmenuOffers = orderBy(content?.submenuOffersCategory?.submenuOffer, ['order']);

  const goToOffer = (offer) => {
    if (offer?.link) window.location.href = offer.link;
  };

  return (
    <div className={clsx('submenu', classes)}>
      <div className="col-span-8 grid gap-8 pt-4 lg:grid-cols-3 lg:py-16 lg:pl-8">
        {orderedSubmenuCategory?.map((item, index) => (
          <div className="flex flex-col gap-4" key={`${item.title}-${index}`}>
            <h3 className="h3 min-h-[1.25rem]">{item.title}</h3>
            <ul className="lg:grow">
              {item?.submenuItem?.map((link, j) => (
                <li key={`${link.text}-${j}`} className="mb-4 last:mb-0 flex items-center gap-4">
                  <Link to={link?.link ?? routes.home.path} onClick={() => setMenuOpen(false)}>
                    {link.text}
                  </Link>

                  {link?.featuredImage && (
                    <div className="w-12 h-full mb-px">
                      <StrapiImg image={link.featuredImage} className="w-full h-full object-cover" />
                    </div>
                  )}
                </li>
              ))}
            </ul>

            {item?.seeAllLinkLabel && (
              <Link to={item.seeAllLink} onClick={() => setMenuOpen(false)} className="flex gap-2 cursor-pointer">
                <span className="text-primary-500 uppercase font-semibold hover:text-yellow-500">
                  {item.seeAllLinkLabel}
                </span>
                <Icon name="chevron-right" classes="text-yellow-500" />
              </Link>
            )}
          </div>
        ))}
      </div>

      <div className="hidden col-span-4 bg-gray-100 rounded-r-3xl px-10 py-16 lg:block">
        <h3 className="h3">{content?.submenuOffersCategory?.title}</h3>
        <div className="offers">
          {orderedSubmenuOffers?.map((item) => (
            <div className={clsx('item-offer', item?.link && 'link')} key={item.title} onClick={() => goToOffer(item)}>
              <StrapiImg image={item.thumbnail} className="w-20 h-20 object-cover rounded-2xl" />

              <div className="item-offer-text">
                <h4 className="uppercase font-semibold">{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SubMenu.propTypes = {
  content: object.isRequired,
  setMenuOpen: func.isRequired,
  classes: string
};
export default SubMenu;
